export class VideoGallery {
    videoItems: Array<HTMLElement>;
    videoTitleBlock: HTMLElement;
    videoGalleryDescription: HTMLElement;
    galeryPlayerIframe: HTMLElement;
    constructor(videoGalleryBlock) {
        this.videoItems = videoGalleryBlock.querySelectorAll('.videoItem-block');
        this.videoTitleBlock = videoGalleryBlock.querySelector('.wistia_video_title');
        this.videoGalleryDescription = videoGalleryBlock.querySelector('.wistia_video_description');
        this.galeryPlayerIframe = videoGalleryBlock.querySelector('.video-galery-player-container .video-iframe');
        this.init();
    }
    init() {
        if (this.videoItems.length > 0) {
            this.updateVideoBlock(this.videoItems[0]);

            this.videoItems.forEach((videoItem) => {
                videoItem.addEventListener('click', (e) => {
                    if (!videoItem.classList.contains('active')) {
                        this.updateVideoBlock(videoItem);
                    }                   
                });
            })
        }
    
    }

    updateVideoBlock(item: HTMLElement) {
        this.setActiveClassToGalleryItem(item);

        this.showActivePlayer(this.galeryPlayerIframe, item); // Show Player

        this.createVideoGaleryTitle(item.querySelector('.videoTitle').textContent || '');

        if (this.videoGalleryDescription) {
            this.videoGalleryDescription.innerHTML = item.getAttribute('data-video-description');
            //this.videoDescriptionBlock(item.getAttribute('data-video-description'))
        };
    }

    setActiveClassToGalleryItem(item: HTMLElement) {
        this.videoItems.forEach(element => element.classList.remove('active'))
        item.classList.add('active');
    }

    createVideoGaleryTitle(textContent: string): void {
        if (this.videoTitleBlock) {
            this.videoTitleBlock.innerHTML = '';
            const titleEl = document.createElement('p')
            titleEl.textContent = textContent;
            this.videoTitleBlock.append(titleEl);
        }
    }

    getLinksByType(videoItem) {
        const type = videoItem.getAttribute('data-video-type')
        let url;
        let iFrame;
        switch (type) {
            case 'youtube-player':
                url = `https://www.youtube.com/embed/${videoItem.getAttribute('data-video-id')}?start=${videoItem.getAttribute('data-video-start')}&rel=0&showinfo=0&enablejsapi=1`;
                iFrame = `<iframe src="${url}" title="${videoItem.getAttribute('data-title')}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>`;
                break;
            case 'vimeo-player':
                url = `https://player.vimeo.com/video/${videoItem.getAttribute('data-video-id')}`;
                iFrame = `<iframe frameborder="0" src='${url}' allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`;
                break;
            case 'brandfolder-player':
                url = `https://brandfolder.com/cpsdigitalassets/attachments/embed/${videoItem.getAttribute('data-video-id')}?resource_type=Brandfolder&frame=auto&animated=false&loop=false&muted=false&autoplay=false`;
                iFrame = ` <iframe src='${url}' frameborder='0' allowfullscreen></iframe>`
                break;
            case 'wistia-player':
                url = `https://fast.wistia.net/embed/iframe/${videoItem.getAttribute('data-video-id')}?seo=true&videoFoam=false`
                iFrame = `<iframe frameborder="0"src="${url}" title="${videoItem.getAttribute('data-title')}" allow="autoplay; fullscreen" allowtransparency="true" scrolling="no" class="wistia_embed" name="wistia_embed" msallowfullscreen width="640" height="360"></iframe>`;
                break;
        }
        return iFrame;
    }

    showActivePlayer(iframeContainer, itemBlock) {
        if (iframeContainer) {
            const iframeData = this.getLinksByType(itemBlock);
            if (iframeData) {
                iframeContainer.innerHTML = iframeData;
            }
        }
    }

    videoDescriptionBlock(videoDescription) {
        if (videoDescription !== '') {
            const button = document.createElement('button');
            button.setAttribute('type', 'button')
            button.setAttribute('aria-expanded', `false`);
            button.setAttribute('class', `vGaleryBtn un-button dropdown-btn videoGaleryAccordion`);
            button.innerHTML = '<span class="directory-filter-dropdown-indicator accordion-item-indicator" tabindex="-1" aria-hidden="false"></span>';
            this.videoTitleBlock.append(button);

            this.showVideoDescription(button, this.videoGalleryDescription)
        }
    }

    showVideoDescription(button, panel) {
        button.addEventListener('click', () => {
            button.classList.toggle('active');
            panel.style.display = panel.style.display === 'block' ? 'none' : 'block';
        });
    }

}